import React from 'react';

import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import maskImage from "../../../../../src/assets/img/slider-mask.webp";
import { BannerInterface } from '../../../Services/types';
interface BannerSectionInterface {
    banners: BannerInterface[]
}

const clearHtml = (content: string): string => {
    return content.replace(/<(?!br\s*\/?)[^>]+>/gi, '');
};

const BannerSection: React.FC<BannerSectionInterface> = ({banners}: BannerSectionInterface) => {

    return (
        <section className="relative w-full bg-main-pink">
            <div className="max-w-[1920px] mx-auto">
                <div className="block relative max-w-[1920px] mx-auto w-full h-[500px] md:h-[550px] lg:h-[600px] 2xl:h-[850px] overflow-hidden banner-mask"
                    style={{
                        maskImage: `url(${maskImage})`,
                        WebkitMaskImage: `url(${maskImage})`,
                        maskSize: '100% 100%',
                        WebkitMaskSize: '100% 100%',
                        maskPosition: 'center bottom',
                        WebkitMaskPosition: 'center bottom',
                    }}
                >
                    <Swiper
                        loop
                        className='relative h-full'
                        slidesPerView={1}
                        modules={[Autoplay]}
                        autoplay={{ delay: 7000 }}
                    >
                        {banners.map((banner) => (
                            <SwiperSlide key={banner.id}>
                                <a href={banner.link ? banner.link : ''} title={banner.titulo} className="inline-block h-[500px] md:h-[550px] lg:h-[600px] 2xl:h-[850px] w-full relative">
                                    <div className="absolute top-0 left-0 h-full lg:h-[calc(100%-150px)] w-full flex items-center z-20">
                                        <div className="max-w-screen-xl mx-auto w-full px-8">
                                            {banner.textoInicial && 
                                                <div className='text-2xl md:text-3xl text-white font-semibold' dangerouslySetInnerHTML={{ __html: banner.textoInicial }} />
                                            }

                                            {banner.tituloDestaque && 
                                                <div className="relative z-10">
                                                    <h2 className={`text-4xl md:text-6xl 2xl:text-7xl font-bold ${banner.corTitulo1 || banner.corTitulo2 ? 'text-shadow-custom  tracking-[8px]' : ''} text-white leading-[50px] md:leading-[70px] 2xl:leading-[90px]`} dangerouslySetInnerHTML={{ __html: banner.tituloDestaque }} />

                                                    {banner.corTitulo1 &&
                                                        <div className={`absolute top-1 md:top-1.5 left-1 -z-10 text-4xl md:text-6xl 2xl:text-7xl font-bold text-shadow-custom tracking-[8px] md:tracking-[9px] leading-[50px] md:leading-[70px] 2xl:leading-[90px]`} style={{ color: banner.corTitulo1 }} dangerouslySetInnerHTML={{ __html: clearHtml(banner.tituloDestaque) }} />
                                                    }

                                                    {banner.corTitulo2 &&
                                                        <div className={`absolute top-2 md:top-3 left-2 -z-20 text-4xl md:text-6xl 2xl:text-7xl font-bold text-shadow-custom tracking-[8px] md:tracking-[9.5px] leading-[50px] md:leading-[70px] 2xl:leading-[90px]`} style={{ color: banner.corTitulo2 }} dangerouslySetInnerHTML={{ __html: clearHtml(banner.tituloDestaque) }} />
                                                    }
                                                </div>
                                            }

                                            <div className="mt-8 flex items-center gap-8">
                                                {banner.data && (() => {
                                                    const date = new Date(banner.data);

                                                    return (
                                                        <div className="flex flex-col shrink-0 h-28 text-center w-20">
                                                            <div style={{ background: banner.corPrincipal, borderColor: banner.corPrincipal}} className="flex items-center justify-center bg-main-pink border-2 border-main-pink rounded-t-xl text-white text-5xl font-semibold h-1/2 transition-all duration-200">
                                                                {date.toLocaleDateString('pt-br', { day: '2-digit' })}
                                                            </div>
                                                            <div className="flex flex-col items-center justify-center border-2 text-white border-white rounded-b-xl shrink-0 h-1/2 py-2 px-0">
                                                                <span className="text-2xl font-semibold tracking-wider uppercase -mt-1">
                                                                    {date.toLocaleDateString('pt-br', { month: 'short' }).replace('.', '')}
                                                                </span>
                                                                <span className="text-base font-semibold tracking-[3px] indent-[2px] -mt-1">
                                                                    {date.toLocaleDateString('pt-br', { year: 'numeric' })}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })()}

                                                {banner.textoData &&
                                                    <div className="text-2xl text-white" dangerouslySetInnerHTML={{ __html: banner.textoData }} />
                                                }
                                            </div>
                                            
                                            {banner.botao &&
                                                <div style={{ background: banner.corPrincipal && banner.corPrincipal }} className={`text-white text-center rounded-full py-2 md:py-4 px-12 md:px-14 text-xl font-semibold mt-8 inline-block`}>
                                                    {banner.botao}
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <img src={banner.imagem} alt={`${banner.titulo}`} className="object-cover w-full h-full hidden lg:block" />

                                    {banner.imagemMobile && 
                                        <img src={banner.imagemMobile} alt={`${banner.titulo} mobile`} className="object-cover w-full h-full block lg:hidden z-10" />
                                    }
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default BannerSection;
